import {Analytics, resetData, setAdobeDigialData} from './analytics'

const AnalyticsHandler = {}

const isTrackingAllowed = () => {
  const isAnalyticsEnabled =
    process.env.NODE_ENV === 'production'
      ? globalThis.__env.REACT_APP_ANALYTICS_ENABLED === 'true'
      : process.env.REACT_APP_ANALYTICS_ENABLED === 'true'

  const isUserfeedbackAllowed = localStorage.getItem('isUserfeedbackAllowed') === 'true'
  const eventParticipantJob = sessionStorage.getItem('eventParticipantJob') // if value exists, it means participant session is in progress

  const isParticipantSessionInProgress = Boolean(eventParticipantJob)
  const isTrackingBlocked = !isAnalyticsEnabled || (isUserfeedbackAllowed && !isParticipantSessionInProgress)
  return !isTrackingBlocked
}

const trackEvent = (eventName, data) => {
  if (!isTrackingAllowed()) return
  resetData() // This will update user data from session storage
  setAdobeDigialData(data)
  globalThis._satellite?.track(eventName)
}

AnalyticsHandler.onPageLoad = function (params) {
  if (!isTrackingAllowed()) return
  resetData() // This will also update user data
  Analytics.digitalData.page.pageInfo.pageName = params.pageName
  globalThis._satellite?.track('page_load')
}

AnalyticsHandler.onFilterApply = function (params) {
  trackEvent('hp_apply_filter', {filter: {...params}})
}

AnalyticsHandler.onExport = function (params) {
  trackEvent('hp_export', {export: params})
}

AnalyticsHandler.onDashboardButtonClick = function (params) {
  trackEvent('hp_dashboard', {dashboard: params})
}

AnalyticsHandler.onChatbotButtonClick = function (params) {
  trackEvent('hp_chatbot', {chatbot: params})
}

AnalyticsHandler.onStateApply = function (params) {
  trackEvent('hp_apply_state', {state: params})
}
AnalyticsHandler.onUsecaseSelect = function (params) {
  trackEvent('hp_usecase', {usecase: params})
}
AnalyticsHandler.onPersonaToggle = function (params) {
  trackEvent('hp_persona_toggle', {personaToggle: params})
}
AnalyticsHandler.onPersonaSelect = function (params) {
  trackEvent('hp_persona', {persona: params})
}
AnalyticsHandler.onMapViewSelect = function (params) {
  trackEvent('hp_mapview', {preferredMapView: params})
}
AnalyticsHandler.onError = function (params) {
  trackEvent('hp_error', {error: params})
}

export {AnalyticsHandler}
